import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import Component from './Component';
import startupConfigSelectors from '../../StartupConfig/selectors';
import { StartupConfigValues } from '../../../lib/startupConfig';

const mapStateToProps = createSelector(
  startupConfigSelectors.selectConfiguration,
  startupConfigSelectors.selectIsConfigurationSet,
  (configuration: StartupConfigValues, isConfigurationSet: boolean) => ({
    configuration,
    isConfigurationSet,
  })
);

export default connect(mapStateToProps)(Component);
